import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Skeleton } from 'src/common';
import { TendersNav } from 'src/shared';
import TaskNav from '../TaskNav';
import { Paths } from '../../paths';
import TaskContent from '../TaskContent';
import { useTaskNav } from 'src/models/bids/BidTask/hooks';
import { BidQuestionType } from 'src/models/bids/BidFull/types';
import { TasksProvider } from 'src/models/bids/BidFull/providers';

export const TaskPageContainer: FC = () => {
  const { data: nav, loading } = useTaskNav();

  return loading ? (
    <Skeleton loading active />
  ) : nav ? (
    <TasksProvider groupId={nav.groupId} withGenerated={nav.type === BidQuestionType.Generated}>
      <TendersNav isNarrow />
      <TaskNav />
      <Routes>
        <Route path={Paths.TASK_PAGE} element={<TaskContent />} />
      </Routes>
    </TasksProvider>
  ) : null;
};

export default TaskPageContainer;
